/* eslint-disable i18next/no-literal-string */
import { Modal, tokens, Link } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { useHelpHotjarUrl } from '@hotjar/translations';

const TargetingType = styled.section`
  margin-top: ${tokens.spacer.x2};
`;
const Description = styled.span`
  ${tokens.text('body2')};
  display: block;
`;
const Label = styled.label`
  ${tokens.text('subtitle2')};
  display: block;
  margin-bottom: 0;
  text-transform: none;
`;
const StyledModalBody = styled(Modal.Body)`
  padding-bottom: ${tokens.spacer.x6};
`;

export interface PagesTargetingModalProps {
  onModalClose: () => void;
  isModalOpen: boolean;
}

export function PagesTargetingModal({
  onModalClose,
  isModalOpen,
}: PagesTargetingModalProps): JSX.Element {
  const helpHotjarUrl = useHelpHotjarUrl();

  return (
    <Modal contentLabel="Modal Example" isOpen={isModalOpen} onClose={onModalClose}>
      <Modal.Header title="Targeting types" />
      <StyledModalBody>
        <TargetingType>
          <Label>URL</Label>
          <Description> Target specific pages by entering exact URLs.</Description>
          <Link
            kind="standalone"
            isExternal
            href={`${helpHotjarUrl}/articles/115014943188-Page-Targeting-for-Feedback-Tools`}
          >
            Learn more
          </Link>
        </TargetingType>
        <TargetingType>
          <Label>Events</Label>
          <Description>Target a specific audience based on what users do.</Description>
          <Link kind="standalone" isExternal href={`${helpHotjarUrl}/articles/115011624487`}>
            Learn more
          </Link>
        </TargetingType>
        <TargetingType>
          <Label>Regular expressions</Label>
          <Description>
            Target specific strings or patterns within URLs, or block certain IP addresses.
          </Description>
          <Link
            kind="standalone"
            isExternal
            href={`${helpHotjarUrl}/articles/115012727628-Using-Regular-Expressions-to-Target-Multiple-Pages`}
          >
            Learn more
          </Link>
        </TargetingType>
      </StyledModalBody>
    </Modal>
  );
}
